import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////

const BG = {
	page: 'PageError',
	brandColor: 'color-brand-orange-400',
	title: 'Грешка',
	list: [],
	additionalText: 'Страницата която търсите не съществува или не може да бъде открита. Върнете се на начална страница или се свържете с нас, ако се нуждаете от съдействие!',
	textColor: 'white',
	showNavigation: false,
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'PageError',
	brandColor: 'color-brand-orange-400',
	title: 'Error',
	list: [],
	additionalText: 'The page you are looking for can not be found. Go back to home page or contact us if you need assistance!',
	textColor: 'white',
	showNavigation: false,
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];